import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ButtonComponent } from 'ui-elements/button';
import { ModalComponent } from 'ui-elements/modal';
import { InfoModal } from 'www-cms';
import { DirectusDirective } from 'directus';
import {
  trigger,
  transition,
  query,
  style,
  animate,
} from '@angular/animations';

@Component({
  selector: 'ss-www-info-modal',
  imports: [CommonModule, ModalComponent, ButtonComponent, DirectusDirective],
  templateUrl: './info-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('modalAnimation', [
      transition(':enter', [
        query(
          '.modal',
          [
            style({ opacity: 0, transform: 'scale3d(0.3, 0.3, 0.3)' }),
            animate(
              '0.3s ease-in-out',
              style({ opacity: 1, transform: 'scale3d(1, 1, 1)' })
            ),
          ],
          { optional: true }
        ),
      ]),
    ]),
  ],
})
export class InfoModalComponent {
  modalOpen = new BehaviorSubject<boolean>(true);
  @Input({ required: true }) modalData!: InfoModal;
}
